import React from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";
import IsValidName from "../../../../utils/validators/IsValidName";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import store from "../../../../store/store";
import { Box, Grid, TextField, Typography } from "@material-ui/core";

const initialState = {
	id: 0,
	name: "",
	volume: 0.6,
	silenceEdgeMs: 0,
	isLoading: false,
	isEditing: false,
	errors: {}
};

export default class PresetsForm extends React.Component {
	constructor(props) {
		super(props);

		const { auth } = store.getState();

		this.state = {
			...initialState,
			userLogged: auth.user,
		};

		this.api = new MutantApiService();

		this.handleChange = this.handleChange.bind(this);
		this.onCleanForm = this.onCleanForm.bind(this);
		this.submit = this.submit.bind(this);
		this.validateForm = this.validateForm.bind(this);
	}

	formIsValid = () => {
		const { name, volume, silenceEdgeMs } = this.state;
		console.log(name, volume, silenceEdgeMs);
		const valid = (
			name &&
			name.trim() !== "" &&
			IsValidName(name) &&
			volume >= 0 &&
			volume <= 2 &&
			silenceEdgeMs >= 0 &&
			Number.isInteger(silenceEdgeMs)
		);
		console.log("Form valid:", valid);
		return valid;
	};

	componentDidMount() {
		const { id } = this.props.match.params;
		if (id) {
			this.loadPreset(id);
		}
	}

	loadPreset = async id => {
		try {
			this.setState({ isLoading: true });

			const response = await this.api.makeHttpRequest({
				method: "GET",
				url: `/presets/${id}`
			});

			const preset = response;
			this.setState({
				id: preset.id,
				name: preset.name || "",
				volume: preset.volume || 0.6,
				silenceEdgeMs: preset.silenceEdgeMs || 0,
				isEditing: true,
			});
		} catch (error) {
			console.error(error);
			Swal.fire("Erro!", "Erro ao carregar dados do preset.", "error");
		} finally {
			this.setState({ isLoading: false });
		}
	};

	handleChange = e => {
		const { name, value } = e.target;

		let parsedValue = value;

		if (name === "volume") {
			if (value === "") {
				parsedValue = "";
			} else {
				parsedValue = parseFloat(value);
				if (isNaN(parsedValue)) parsedValue = 0;
			}
		} else if (name === "silenceEdgeMs") {
			if (value === "") {
				parsedValue = "";
			} else {
				parsedValue = parseInt(value, 10);
				if (isNaN(parsedValue)) parsedValue = 0;
			}
		}

		this.setState(prev => {
			const newErrors = { ...prev.errors };
			delete newErrors[name];
			return { [name]: parsedValue, errors: newErrors };
		}, () => {
			this.validateForm();
		});
	};

	validateForm = () => {
		const errors = {};
		const { name, volume, silenceEdgeMs } = this.state;

		if (!name || name.trim() === "") {
			errors.name = "Nome é obrigatório";
		} else if (!IsValidName(name)) {
			errors.name = "Nome inválido";
		}

		if (volume < 0 || volume > 2) {
			errors.volume = "Volume deve estar entre 0 e 2";
		}

		if (silenceEdgeMs < 0) {
			errors.silenceEdgeMs = "Silence Edge deve ser maior ou igual a 0";
		}

		if (!Number.isInteger(silenceEdgeMs)) {
			errors.silenceEdgeMs = "Silence Edge deve ser um número inteiro";
		}

		this.setState({ errors });
		return Object.keys(errors).length === 0;
	};

	submit = async e => {
		e.preventDefault();
		console.log("Submitting form...");
		const formIsValid = this.formIsValid();
		const validationPassed = this.validateForm();
		console.log("Form is valid:", formIsValid, "Validation passed:", validationPassed);
		if (!validationPassed) {
			return;
		}

		if (!formIsValid) {
			Swal.fire("Atenção!", "Preencha todos os campos corretamente.", "warning");
			return;
		}

		try {
			this.setState({ isLoading: true });

			const { id, name, volume, silenceEdgeMs, isEditing } = this.state;

			const data = {
				name,
				volume: parseFloat(volume.toFixed(4)),
				silenceEdgeMs: parseInt(silenceEdgeMs, 10)
			};

			if (isEditing) {
				await this.api.makeHttpRequest({
					method: "PATCH",
					url: `/presets/${id}`,
					data
				});
			} else {
				await this.api.makeHttpRequest({
					method: "POST",
					url: "/presets",
					data
				});
			}
			this.setState({ isLoading: false });

			await Swal.fire({
				title: "Sucesso!",
				text: `Preset ${isEditing ? "atualizado" : "criado"} com sucesso.`,
				icon: "success"
			});

			this.props.history.push("/dashboard/presets");
		} catch (error) {
			console.error("Erro ao salvar preset:", error);
			const apiData = error?.response?.data;
			if (apiData) {
				if (Array.isArray(apiData.messages) && apiData.messages.length > 0) {
					const backendFirst = apiData.messages[0];
					if (backendFirst === "Preset name must be unique") {
						Swal.fire("Erro!", "Já existe um preset com esse nome", "error");
					} else {
						Swal.fire("Erro!", backendFirst, "error");
					}
				} else if (apiData.message) {
					Swal.fire("Erro!", apiData.message, "error");
				} else {
					Swal.fire("Erro!", "Erro ao salvar preset.", "error");
				}
			}
		} finally {
			this.setState({ isLoading: false });
		}
	};

	onCleanForm = () => {
		this.setState({ ...initialState });
	};

	render() {
		const { name, volume, silenceEdgeMs, isLoading, isEditing, errors } = this.state;

		return (
			<>
				<Loading isLoading={isLoading} />
				<AdminTitle
					title={isEditing ? "Editar Preset" : "Criar Novo Preset"}
					subtitle={
						isEditing
							? "Atualize as informações do preset"
							: "Preencha os dados para criar um novo preset"
					}
				/>
				<Card className="mt-4" style={{ width: "100%", margin: "0 auto" }}>
					{" "}
					<Box>
						<StyledCardBody minHeight="550px">
							<Grid container>
								<Grid
									item
									xs={12}
									sm={12}
									style={{
										marginBottom: "30px"
									}}
								>
									<Form onSubmit={this.submit}>
										<Grid container spacing={3}>
											<Grid item xs={12}>
												<InputField
													label="Nome"
													name="name"
													value={name}
													onChange={this.handleChange}
													error={!!errors.name}
													helperText={errors.name}
													required
													fullWidth
												/>
											</Grid>

											<Grid item xs={12} md={6}>
												<TextField
													label="Volume"
													name="volume"
													type="number"
													value={volume}
													onChange={this.handleChange}
													error={!!errors.volume}
													helperText={errors.volume || "Valor entre 0 e 2 (até 4 casas decimais)"}
													required
													fullWidth
													inputProps={{
														step: "0.0001",
														min: "0",
														max: "2"
													}}
												/>
											</Grid>

											<Grid item xs={12} md={6}>
												<TextField
													label="Silence Edge (ms)"
													name="silenceEdgeMs"
													type="number"
													value={silenceEdgeMs}
													onChange={this.handleChange}
													error={!!errors.silenceEdgeMs}
													helperText={errors.silenceEdgeMs || "Valor inteiro maior ou igual a 0"}
													required
													fullWidth
													inputProps={{
														step: "1",
														min: "0"
													}}
												/>
											</Grid>

											<Grid item xs={12}>
												<Box mt={2}>
													<Typography variant="body2" color="textSecondary">
														<strong>Volume:</strong> Controla a amplitude do áudio (0 = silencioso, 1 = normal, 2 = dobro do volume)
													</Typography>
													<Typography variant="body2" color="textSecondary" style={{ marginTop: '8px' }}>
														<strong>Silence Edge:</strong> Remove silêncio das bordas do áudio em milissegundos
													</Typography>
												</Box>
											</Grid>
										</Grid>

										<FormActions
											onCancel={() => this.props.history.push("/dashboard/presets")}
											onCleanForm={this.onCleanForm}
											onSubmit={this.submit}
											isEdit={isEditing}
											formIsValid={this.formIsValid()}
										/>
									</Form>
								</Grid>
							</Grid>
						</StyledCardBody>
					</Box>
				</Card>
			</>
		);
	}
}